import type { DailyStatistic } from '@features/statistics/types'
import type {
  DailyStatisticDto,
  DailyStatisticsDto,
} from '@shared/api/statistics.dto'

/** Преобразует backend DTO статистики в доменную модель. */
export const mapDailyStatisticDto = (
  dto: DailyStatisticDto,
): DailyStatistic => ({
  value: dto.value,
  splitValue: dto.splitted_value,
  unit: dto.unit,
  title: dto.title,
})

/** Преобразует backend-ответ статистики в список доменных моделей. */
export const mapDailyStatisticsDto = (
  dto: DailyStatisticsDto,
): DailyStatistic[] => (dto.statistics ?? []).map(mapDailyStatisticDto)
